import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import { StyleDeclarationValue, css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { IEditEmailTemplateComponent, IEditEmailTemplateContent } from '../../../../models';
import {
	ErrorMessagesViewModelKey,
	IErrorMessageComponentProps,
	IUserSessionComponentProps,
	UserSessionViewModelKey,
} from '../../../../models/AppState';
import { CreateCampaignApprovalViewModel } from '../../../../viewmodels/AdminViewModels';
import { MultiContainerHeader } from '../../../../web/components/MultiContainerHeader';
import { ManageEmailTemplates } from '../../../../web/containers/templates/ManageEmailTemplates';
import { baseStyleSheet } from '../../../../web/styles/styles';

interface IProps
	extends IEventLoggingComponentProps,
		IUserSessionComponentProps,
		RouteComponentProps<any>,
		IErrorMessageComponentProps {
	approval: CreateCampaignApprovalViewModel;
	className?: string;
	onFinish?(content?: IEditEmailTemplateContent): void;
	styles?: StyleDeclarationValue[];
}

class _BulkEmailApprovalMessageEditor extends React.Component<IProps> {
	private mEditTemplateRef?: IEditEmailTemplateComponent;

	public componentDidMount() {
		const { logPageView } = this.props;

		logPageView('BulkEmailApprovalMessageEditor');
	}

	public render() {
		const { approval } = this.props;
		return (
			<ManageEmailTemplates
				attachments={approval?.files}
				defaultTemplatesIndustry={approval?.account?.additionalInfo?.industry}
				disableDelete={true}
				disableSharing={true}
				disableTemplateEdits={true}
				newContentCtaText='New email'
				onInnerEditorRef={this.onInnerEditorRef}
				onlySystemTemplates={true}
				onRenderFooterAction={this.onRenderFooterActionButton}
				onRenderFullscreenHeader={this.onRenderFullscreenHeader}
			/>
		);
	}

	private onRenderFullscreenHeader = (onCloseClicked: (e?: React.MouseEvent<HTMLElement>) => void) => {
		return (
			<MultiContainerHeader
				fullscreenHeader='Schedule Email for Clients: Select Template'
				onFullscreenRequestClose={onCloseClicked}
			/>
		);
	};

	private onRenderFooterActionButton = () => {
		return (
			<>
				<button className={css(baseStyleSheet.ctaButton)} onClick={this.onScheduleClicked}>
					<span>Schedule Email</span>
				</button>
			</>
		);
	};

	private onInnerEditorRef = (ref?: IEditEmailTemplateComponent) => {
		this.mEditTemplateRef = ref;
	};

	private onScheduleClicked = () => {
		if (this.mEditTemplateRef?.getContent) {
			const { onFinish, errorMessages } = this.props;
			const content = this.mEditTemplateRef.getContent();
			if (!content?.subject) {
				errorMessages.push({
					messages: ['Please provide a subject.'],
				});
				return;
			}

			if (!content?.editorState?.hasContent()) {
				errorMessages.push({
					messages: ['Please provide email content.'],
				});
				return;
			}
			if (onFinish) {
				onFinish(content);
			}
		}
	};
}

const BulkEmailApprovalMessageEditorAsObserver = observer(_BulkEmailApprovalMessageEditor);
const BulkEmailApprovalMessageEditorWithContext = inject(
	UserSessionViewModelKey,
	ErrorMessagesViewModelKey
)(BulkEmailApprovalMessageEditorAsObserver);
export const BulkEmailApprovalMessageEditor = withEventLogging(
	BulkEmailApprovalMessageEditorWithContext,
	'BulkEmailApprovalMessageEditor'
);
